var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCouponsRedeemedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21028_37734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8332 6.77075C10.8332 7.48905 10.5478 8.17792 10.0399 8.68583C9.53201 9.19374 8.84313 9.47909 8.12484 9.47909C7.40654 9.47909 6.71767 9.19374 6.20976 8.68583C5.70185 8.17792 5.4165 7.48905 5.4165 6.77075",
    stroke: "#00C49A",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.10107 4.08545H14.1491",
    stroke: "#00C49A",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.30208 3.7017C2.12628 3.9361 2.03125 4.22119 2.03125 4.5142V13.5417C2.03125 13.9009 2.17392 14.2453 2.42788 14.4993C2.68183 14.7532 3.02627 14.8959 3.38542 14.8959H12.8646C13.2237 14.8959 13.5682 14.7532 13.8221 14.4993C14.0761 14.2453 14.2187 13.9009 14.2187 13.5417V4.5142C14.2187 4.22119 14.1237 3.9361 13.9479 3.7017L12.5937 1.89591C12.4676 1.72773 12.3041 1.59123 12.116 1.49721C11.928 1.40319 11.7206 1.35425 11.5104 1.35425H4.73958C4.52936 1.35425 4.32201 1.40319 4.13398 1.49721C3.94595 1.59123 3.78239 1.72773 3.65625 1.89591L2.30208 3.7017Z",
    stroke: "#00C49A",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21028_37734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.25,
    height: 16.25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponsRedeemedIcon);
export default __webpack_public_path__ + "static/media/coupons-redeemed-icon.a9e56b0182e30ab822735e3610a27f95.svg";
export { ForwardRef as ReactComponent };